import { createTRPCReact } from '@trpc/react-query';
import type { inferRouterInputs, inferRouterOutputs } from '@trpc/server';
import type { AppRouter } from '@apps/trpc';

export type OrderData = inferRouterOutputs<AppRouter>['admin']['order']['adminListOrders'];
export type Order = RouterOutput['admin']['order']['adminGetOrderRelatedInfoById']['order'];
export type OrderPayment = NonNullable<
  RouterOutput['admin']['order']['adminGetOrderRelatedInfoById']['order']['payments']
>[number];
export type OrderContainer =
  RouterOutput['admin']['order']['adminGetOrderRelatedInfoById']['containers'][number];
export type OrderExpandedContainer =
  RouterOutput['admin']['order']['adminExpandOrderContainers'][number];
export type Cart = RouterOutput['admin']['order']['adminGetOrderRelatedInfoById']['cart'];
export type Container =
  RouterOutput['admin']['container']['getAllContainers']['containers'][number];
export type CustomerExport =
  RouterOutput['admin']['customer']['adminExportCustomers']['customers'][number];
export type Customer = RouterOutput['admin']['customer']['adminListCustomers']['customers'][number];
export type Lead = RouterOutput['admin']['leads']['adminListLeads']['leads'][number];
export type LeadExport = RouterOutput['admin']['leads']['adminExportLeads']['leads'][number];
export type MarketingConsentRecord =
  RouterOutput['admin']['marketing']['adminListMarketingConsent']['records'][number];
export type MarketingConsentExport =
  RouterOutput['admin']['marketing']['adminExportMarketingConsent']['records'][number];
export type User = RouterOutput['admin']['user']['adminGetAllUsers']['users'][number];
export type AddOn = RouterOutput['admin']['addOn']['getAddOn'];
export type Product = RouterOutput['admin']['product']['getProduct'];
export type ContainerType =
  RouterOutput['admin']['containerType']['getAllContainerTypes']['containerTypes'][number];
export type Organization =
  RouterOutput['admin']['organization']['getAllOrganizations']['organizations'][number];
export type CoverageArea =
  RouterOutput['admin']['organization']['getUnassignedCoverageAreas'][number];
export type Driver = RouterOutput['admin']['driver']['getAllDrivers']['drivers'][number];
export type Truck = RouterOutput['admin']['truck']['getAllTrucks']['trucks'][number];
export type Cleanup = RouterOutput['admin']['cleanup']['getCleanups']['cleanups'][number];
export type ContainerInput =
  RouterInput['admin']['order']['adminUpsertOrderContainers']['containers'][number];
export type Invoice = RouterOutput['admin']['invoice']['adminGetInvoiceById'];
export type InvoiceItem = RouterOutput['admin']['invoice']['adminGetInvoiceById']['items'][number];
export type InvoiceStatus =
  RouterOutput['admin']['invoice']['adminListInvoices']['invoices'][number]['status'];
export type InvoiceWithUserData =
  RouterOutput['admin']['invoice']['adminListInvoices']['invoices'][number];
export type NoteOrigin = RouterInput['admin']['note']['getNotes']['origin'];
export type Location = RouterOutput['admin']['location']['getAllLocations']['locations'][number];
export type Material = RouterOutput['admin']['material']['getMaterials'][number];

export type RouterInput = inferRouterInputs<AppRouter>;
export type RouterOutput = inferRouterOutputs<AppRouter>;
export const trpc = createTRPCReact<AppRouter>();
